import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20creative%20workspace%20with%20abstract%20geometric%20shapes%20and%20soft%20gradients%2C%20inspirational%20design%20atmosphere%2C%20golden%20and%20coral%20color%20scheme%2C%20clean%20minimalist%20style%2C%20modern%20creative%20studio%20vibe&width=1600&height=600&seq=cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-primary-800/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始您的创作了吗？
        </h2>
        <p className="text-white/80 mb-8 max-w-lg mx-auto">
          加入超过120万创作者社区，免费获取50万+高质量游戏素材、音效和音乐资源
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-6 py-3 rounded-lg bg-white text-primary-600 font-medium hover:bg-background-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            免费注册
          </Link>
          <Link
            to="/category/game-assets"
            className="px-6 py-3 rounded-lg border border-white/40 text-white hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览素材库
          </Link>
        </div>
      </div>
    </section>
  );
}